import { init } from './init'
import { sanitizeData, sanitizeExpire } from './Sanitize'

const actionTypes = {
  FETCH_LOGON: 'FETCH_LOGON',
  RESET: 'RESET',
}

const fetchReset = async state => {
  state = {
    ...state,
    isLoading: false,
    isStatus: true,
    expireToken: false,
    data: false,
  }
  return state
}

const fetchLogon = async (state, logon) => {
  state = {
    ...state,
    isStatus: logon.status,
    expireToken: sanitizeExpire({
      status: logon.status,
      data: logon.data,
      name: 'logonobj',
    }),
    data: sanitizeData({
      status: logon.status,
      data: logon.data,
      name: 'logonobj',
    }),
  }
  return state
}

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_LOGON:
      return fetchLogon(state, action.logon)
    case actionTypes.RESET:
      return fetchReset(state)
    default:
      return state
  }
}

const token = {
  init,
  actionTypes,
  reducer,
}

export default token
